module.exports = __webpack_public_path__ + "/3270d97ee4efd536329b585837af0bd2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/assets/1.png
 ** module id = 1282
 ** module chunks = 0
 **/